module.exports = __webpack_public_path__ + "07_face.6caa70bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/07_face.png
// module id = Tt+u
// module chunks = 0